import { Route } from 'react-router-dom';
import { reconductionsPourImpressionSchema } from './reconductionsPourImpression';
import Main from '@app/main/tables/Main';

/**
 * Routes configurées pour le module ReconductionsPourImpression
 */
const ReconductionsPourImpressionRoutes = [
    // Route de liste (principale)
    <Route
        key="reconductions-pour-impression"
        path="reconductionsPourImpression"
        element={
            <Main
                key="reconductions-pour-impression-main"
                pageConfig={reconductionsPourImpressionSchema}
            />
        }
    />,
];

export default ReconductionsPourImpressionRoutes;
